import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#index', label: '差异索引' },
  { href: '#dimensions', label: '对比维度' },
  { href: '#digest', label: '参考清单' },
  { href: '#guide', label: '平替指引' },
  { href: '#faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          className={`flex items-center gap-2 font-heading text-lg md:text-xl tracking-tight cursor-pointer whitespace-nowrap ${
            scrolled ? 'text-foreground-950' : 'text-background-50'
          }`}
        >
          <span className="w-7 h-7 flex items-center justify-center">
            <i className="ri-article-line text-xl" />
          </span>
          黑料网站
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className={`text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600'
                    : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className={`hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer ${
              scrolled
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600'
                : 'bg-background-50/95 text-foreground-950 hover:bg-background-50'
            }`}
          >
            订阅更新
          </a>
          <button
            type="button"
            aria-label="展开导航"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70 px-4 py-4">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-background-100 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="mt-2 block px-3 py-2.5 rounded-md text-sm text-center bg-primary-500 text-background-50 dark:text-foreground-950 cursor-pointer whitespace-nowrap"
              >
                订阅更新
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}